import request from "../../../utils/request";
import qs from "qs";

export function getPrize(query) {
    return request({
        url: "/v1/user/recharge/v3/h5/price",
        method: "get",
        params: {
            userNumber: query.userNumber ? query.userNumber : '',
            country: query.country ? query.country : '',
            userSelect: query.userSelect,
            channelType: 3
        }
    });
}

export function getCurrentId(query) {
    return request({
        url: "/v1/user/recharge/user/nickname",
        method: "get",
        params: {
            userNumber: query.userNumber ? query.userNumber : ''
        }
    });
}

export function payerMaxCreate(query) {
    return request({
        url: "/v1/user/recharge/tripartite/create",
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        // data:qs.stringify(query) 
        data: {
            priceId: query.priceId ? query.priceId : '',
            channelType: query.channelType ? query.channelType : '',
            userNumber: query.userNumber ? query.userNumber : '',
            paymentType: query.paymentType ? query.paymentType : '',
            bilToken: query.bilToken ? query.bilToken : '',
            bilTempToken: query.bilTempToken ? query.bilTempToken : '',
            email: query.email ? query.email : '',
            sign: query.sign,
            country: query.country ? query.country : '',
            mobileBrowser: query.mobileBrowser,
            screenWidth: query.screenWidth ? query.screenWidth : null,
            screenHeight: query.screenHeight ? query.screenHeight : null,
            colorDepth: query.colorDepth ? query.colorDepth : null,
            jetLag: query.timestamp ? query.timestamp : null,
            checkoutToken: query.checkoutToken ? query.checkoutToken : null,
        }
    });

    // 4581 2306 2562 0127
}

export function SendAjax(query) {
    return request({
        url: "/v1/user/behavior/h5/save",
        method: "post",
        headers: {
            "Content-Type": "application/json"
        },
        data: {
            type: query.type ? query.type : '',
            objectId: query.bannerId ? query.bannerId : '',
            userId: query.userId ? query.userId : ''
        }
    });
}